import { URL } from ".";
import fetchApi from "../util/fetchApi";

export default class ProductService {
  async getAllProducts(params) {

    let queryParams = "";
    let join = "";
    Object.keys(params).forEach(param => {
      if (param) {
        if (param == "search")
          queryParams += join + `${param}=${encodeURIComponent(params[param])}`;
        else
          queryParams += join + `${param}=${params[param]}`;
        join = "&";
      }
    })

    return (
      await fetchApi.get(
        `${URL}/product/list${queryParams ? "?" + queryParams : ""}`
      )
    ).data;
  }

  async getProductById(id) {
    return (await fetchApi.get(`${URL}/product/${id}`)).data;
  }

  async addProduct(formData) {
    return (await fetchApi.post(`${URL}/product`, formData)).data;
  }

  async updateProduct(id, formData) {
    return (await fetchApi.patch(`${URL}/product/${id}`, formData)).data;
  }

  async deleteProduct(id) {
    return (await fetchApi.delete(`${URL}/product/${id}`)).data;
  }

  async getProductsPriceList() {
    return (await fetchApi.get(`${URL}/product/pricelist`)).data;
  }

  async getProductCategories() {
    return (await fetchApi.get(`${URL}/product/categorylist`)).data;
  }
}
